// extracted by mini-css-extract-plugin
module.exports = {"single-lock-item":"Item_single-lock-item__3Cs2V","single-lock-item__image":"Item_single-lock-item__image__1TH3A","single-lock-item__text":"Item_single-lock-item__text__2ol1L"};